import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { Download, Calendar, Filter } from 'lucide-react';
const barData = [{
  name: 'জানু',
  published: 4000,
  rejected: 240
}, {
  name: 'ফেব্রু',
  published: 3000,
  rejected: 139
}, {
  name: 'মার্চ',
  published: 2000,
  rejected: 980
}, {
  name: 'এপ্রিল',
  published: 2780,
  rejected: 390
}, {
  name: 'মে',
  published: 1890,
  rejected: 480
}, {
  name: 'জুন',
  published: 2390,
  rejected: 380
}, {
  name: 'জুলাই',
  published: 3490,
  rejected: 430
}];
const pieData = [{
  name: 'প্রকাশিত',
  value: 65
}, {
  name: 'প্রক্রিয়াধীন',
  value: 15
}, {
  name: 'অপেক্ষমাণ',
  value: 10
}, {
  name: 'প্রত্যাখ্যাত',
  value: 10
}];
const COLORS = ['#0d9488', '#3b82f6', '#f59e0b', '#ef4444'];
export const ReportsPage: React.FC = () => {
  return <div className="max-w-7xl mx-auto" data-id="element-1266">
      <div className="flex justify-between items-end mb-6" data-id="element-1267">
        <div data-id="element-1268">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-1269">
            অ্যানালিটিক্স এবং রিপোর্ট
          </h1>
          <p className="text-slate-500" data-id="element-1270">
            সিস্টেম-ব্যাপী পরিসংখ্যান এবং ডেটা এক্সপোর্ট
          </p>
        </div>
        <div className="flex space-x-3" data-id="element-1271">
          <button className="btn-secondary flex items-center text-sm" data-id="element-1272">
            <Filter size={16} className="mr-2" data-id="element-1273" /> ফিল্টার
          </button>
          <button className="btn-primary flex items-center text-sm" data-id="element-1274">
            <Download size={16} className="mr-2" data-id="element-1275" /> রিপোর্ট এক্সপোর্ট করুন
          </button>
        </div>
      </div>

      {/* Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8" data-id="element-1276">
        <div className="card p-5 border-t-4 border-t-teal-500" data-id="element-1277">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-1278">
            মোট প্রকাশিত
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-1279">১.২ মি</p>
          <p className="text-xs text-teal-600 mt-2 flex items-center" data-id="element-1280">
            ↑ গত মাস থেকে ১২%
          </p>
        </div>
        <div className="card p-5 border-t-4 border-t-blue-500" data-id="element-1281">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-1282">
            প্রক্রিয়াধীন
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-1283">৪৫,২৩০</p>
          <p className="text-xs text-slate-500 mt-2" data-id="element-1284">১২টি জেলা জুড়ে</p>
        </div>
        <div className="card p-5 border-t-4 border-t-amber-500" data-id="element-1285">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-1286">
            যাচাইয়ের অপেক্ষায়
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-1287">১২,৪০০</p>
          <p className="text-xs text-amber-600 mt-2" data-id="element-1288">
            অফিসার পর্যালোচনা প্রয়োজন
          </p>
        </div>
        <div className="card p-5 border-t-4 border-t-red-500" data-id="element-1289">
          <p className="text-sm font-medium text-slate-500 mb-1" data-id="element-1290">
            প্রত্যাখ্যানের হার
          </p>
          <p className="text-3xl font-bold text-slate-900" data-id="element-1291">৪.২%</p>
          <p className="text-xs text-slate-500 mt-2" data-id="element-1292">এই বছরের গড়</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-1293">
        {/* Bar Chart */}
        <div className="card p-6 lg:col-span-2" data-id="element-1294">
          <div className="flex justify-between items-center mb-6" data-id="element-1295">
            <h2 className="font-semibold text-slate-800" data-id="element-1296">
              প্রকাশনার প্রবণতা (২০২৩)
            </h2>
            <select className="input-field py-1 text-sm w-32" data-id="element-1297">
              <option data-id="element-1298">এই বছর</option>
              <option data-id="element-1299">গত বছর</option>
            </select>
          </div>
          <div className="h-80" data-id="element-1300">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1301">
              <BarChart data={barData} margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5
            }} data-id="element-1302">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-1303" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-1304" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748b'
              }} data-id="element-1305" />
                <Tooltip cursor={{
                fill: '#f1f5f9'
              }} contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1306" />
                <Legend data-id="element-1307" />
                <Bar dataKey="published" name="প্রকাশিত" fill="#0d9488" radius={[4, 4, 0, 0]} data-id="element-1308" />
                <Bar dataKey="rejected" name="প্রত্যাখ্যাত" fill="#ef4444" radius={[4, 4, 0, 0]} data-id="element-1309" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Pie Chart */}
        <div className="card p-6" data-id="element-1310">
          <h2 className="font-semibold text-slate-800 mb-6" data-id="element-1311">
            বর্তমান স্ট্যাটাস বন্টন
          </h2>
          <div className="h-64" data-id="element-1312">
            <ResponsiveContainer width="100%" height="100%" data-id="element-1313">
              <PieChart data-id="element-1314">
                <Pie data={pieData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" data-id="element-1315">
                  {pieData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-1316" />)}
                </Pie>
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} data-id="element-1317" />
              </PieChart>
            </ResponsiveContainer>
          </div>
          <div className="mt-4 space-y-2" data-id="element-1318">
            {pieData.map((entry, index) => <div key={index} className="flex items-center justify-between text-sm" data-id="element-1319">
                <div className="flex items-center" data-id="element-1320">
                  <div className="w-3 h-3 rounded-full mr-2" style={{
                backgroundColor: COLORS[index]
              }} data-id="element-1321"></div>
                  <span className="text-slate-600" data-id="element-1322">{entry.name}</span>
                </div>
                <span className="font-medium text-slate-900" data-id="element-1323">
                  {entry.value}%
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};